var _defs, _path, _rect, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDlInstaOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130.65 130.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #b65741;\n      }\n\n      .st1 {\n        fill: #fff;\n      }\n\n      .st2 {\n        fill: none;\n        stroke: #fff;\n        stroke-linejoin: bevel;\n        stroke-width: 4px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.65,65.32c0,34.97-28.35,63.33-63.33,63.33S2,100.3,2,65.32,30.35,2,65.32,2s63.33,28.35,63.33,63.32Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 33.07,
    y: 33.08,
    width: 64.5,
    height: 64.5,
    rx: 15.84,
    ry: 15.84
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 65.32,
    cy: 65.33,
    r: 16.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 84.95,
    cy: 46.33,
    r: 4.04
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDlInstaOrange);
export default __webpack_public_path__ + "static/media/dl_insta-orange.c0777ae5972d37aeecb777ead4f28ed4.svg";
export { ForwardRef as ReactComponent };